module.exports = __webpack_public_path__ + "static/googlePlay3-3ec1dd4c76745bb9fe401fa06331a054.png";